import React, { useState } from 'react';
import classes from 'src/components/Basket/BasketItems.scss';
import { UserKind } from 'src/components/BasketShared/ShareBasketViaEmailForm';
import { BasketItemType } from 'src/components/Basket/BasketContext';
import { Price } from 'src/components/Helpers/Price';
import { ItemDiscount } from 'src/components/BasketItemDiscount/BasketItemDiscount';
import cx from 'classnames';
import { MultipleStepCustomisation } from 'src/components/BundleProduct/MultipleStepCustomisation/MultipleStepCustomisation';
import { useDeps } from 'src/hooks/useDeps';
import { useDispatch } from 'react-redux';
import { handleCreateCustomisationCamel } from 'src/components/Basket/utils/handleCreateCustomisation';
import { Button } from 'src/components/Button/Button';

type BasketItemFooterProps = {
    isPending: boolean;
    userKind: UserKind;
    item: BasketItemType;
    itemPrice: number;
    productDiscount: number;
    customiseProduct: () => void;
};

export const BasketItemFooter: React.FC<BasketItemFooterProps> = ({
    isPending,
    userKind,
    item,
    itemPrice,
    productDiscount,
    customiseProduct,
}) => {
    const { cartItem, availableLocations, customisations } = item;
    const isBundle = cartItem.__typename === 'BundleCartItem';
    const [openModal, setOpenModal] = useState(false);
    const deps = useDeps();
    const dispatch = useDispatch();

    const customisationDiscount = cartItem.customisationDiscount;
    const discountsApplied = productDiscount > 0;

    const totalItemPrice = itemPrice + (item.customisationsCost || 0);
    const totalItemDiscountPrice = itemPrice + (item.customisationsCost || 0) - customisationDiscount - productDiscount;

    const alreadySelectedPositions = customisations.map((customisation) => customisation.location_name);

    const addCustomisation = () => {
        // if (treatment === 'on') {
        //     setOpenModal(true);
        // } else {
        //     customiseProduct();
        // }
        customiseProduct();
    };

    return (
        <div className={classes.basketItemAddButton}>
            <div className={classes.basketItemsBtnAndTotal}>
                {(isBundle || availableLocations.length > 0) && !isBundle && (
                    <>
                        <Button
                            variant="bold"
                            disabled={isPending || customisations.length === availableLocations.length}
                            onClick={addCustomisation}
                            data-test-id="BasketItems_add_customisation"
                            className={classes.basketItemAddLogoBtn}
                        >
                            {item.customisations.length > 0 ? 'Add another logo to this item' : 'Add logo to this item'}
                        </Button>
                        {openModal && (
                            <MultipleStepCustomisation
                                locations={item.availableLocations}
                                isOpenModal
                                closeModal={() => setOpenModal(false)}
                                onSubmitCustomisation={(value) =>
                                    handleCreateCustomisationCamel(
                                        value,
                                        [Number(item.cartItem.id)],
                                        deps,
                                        dispatch,
                                        undefined,
                                        false,
                                    )
                                }
                                alreadySelectedPositions={alreadySelectedPositions}
                                recommendedApplication={0}
                                multiplePositions
                            />
                        )}
                    </>
                )}
            </div>
            <div className={classes.basketItemCostSummary__block}>
                <p>Total item cost:</p>
                {discountsApplied && (
                    <p className={cx(classes.basketItemCostSummary__block__price, classes.beforeDiscount)}>
                        <Price price={totalItemPrice} priceIncl={totalItemPrice} />
                    </p>
                )}
                <p
                    className={cx(
                        classes.basketItemCostSummary__block__price,
                        classes.basketItemCostSummary__block__price__green,
                    )}
                >
                    <Price
                        price={discountsApplied ? totalItemDiscountPrice : totalItemPrice}
                        priceIncl={discountsApplied ? totalItemDiscountPrice : totalItemPrice}
                    />
                </p>
            </div>
            {userKind === UserKind.Csp && (
                <ItemDiscount itemId={Number(item.cartItem.id)} discount={item.csr_discount ?? 0} />
            )}
        </div>
    );
};
